/* @flow weak */
import apiRequest from './apiRequest';
import invariant from 'invariant';

import { result } from 'lodash';

/**
 * Our drop-in for Backbone.sync used in both Entity and Collection
 * The parameters are defined by Backbone. We should never call this directly.
 */
const methodMap = {
  create: 'POST',
  read: 'GET',
  update: 'PUT',
  patch: 'PATCH',
  delete: 'DELETE',
};


/**
 * options.method overrides the defaultMethod arg
*/
export default function sync(defaultMethod, model, options) {
  let url = options.url;
  if (!url) {
    url = result(model, 'url');
  }

  invariant(url, 'A "url" property or function must be specified');

  const method = ('method' in options) ? options.method : defaultMethod;
  let data = options.data;

  if (!data && model && (
    method === 'create' ||
    method === 'update' ||
    method === 'patch')) {
    data = options.attrs || model.toJSON(options);
  }

  return apiRequest(url, methodMap[method] ||
    method, data).then(options.success, options.error);
}



// WEBPACK FOOTER //
// ./src/lib/BackboneSync.js